import * as LiffService from '@/services/liff'
import { store } from '@/store'
import { getUuidV4 } from './uuid'
import { setLocalStorage } from './cacheStorage'

const TIMEOUT_DURATION = 60000

export interface HttpResponse {
  httpStatusCode: number
  json: any
}

const attachDebuggerHeaders = (options: RequestInit) => {
  const headers = new Headers(options.headers)
  const xRequestId = getUuidV4()

  headers.set('x-request-id', window.__LIFF_DEBUGGER_PARAMS.shift() ?? xRequestId)
  options.headers = headers
}

const generateXRequestId = (options: RequestInit) => {
  const headers = new Headers(options.headers)
  const xRequestId = getUuidV4()
  headers.set('x-request-id', xRequestId)
  options.headers = headers
  setLocalStorage('x-request-id', xRequestId)
}

export const get = async (url: string, options?: RequestInit): Promise<HttpResponse> => {
  const controller = new AbortController()
  const timeout = setTimeout(() => {
    controller.abort()
  }, TIMEOUT_DURATION)

  if (!options) {
    options = {}
  }
  await LiffService.validateToken()
  options.method = 'GET'
  options.signal = controller.signal
  generateXRequestId(options)

  if (window && window.__LIFF_DEBUGGER_PARAMS && window.__LIFF_DEBUGGER_PARAMS.length) {
    attachDebuggerHeaders(options)
  }

  try {
    const response = await fetch(url, options)
    const json = await response.json()
    clearTimeout(timeout)
    return {
      httpStatusCode: response.status,
      json,
    }
  } catch (e) {
    clearTimeout(timeout)
    store.dispatch('connectivity/checkOnlineStatus')

    if (e instanceof Error) {
      if (store.state.connectivity.isOnline && e.name === 'AbortError') {
        store.dispatch('connectivity/checkRequestTimeoutStatus')
      }
    }

    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}

export const del = async (
  url: string,
  options?: RequestInit
): Promise<HttpResponse | undefined> => {
  const controller = new AbortController()
  const timeout = setTimeout(() => {
    controller.abort()
  }, TIMEOUT_DURATION)

  const validate = await LiffService.validateToken()
  if (!validate) {
    return
  }
  if (!options) {
    options = {}
  }
  options.method = 'DELETE'
  options.signal = controller.signal
  generateXRequestId(options)

  if (window && window.__LIFF_DEBUGGER_PARAMS && window.__LIFF_DEBUGGER_PARAMS.length) {
    attachDebuggerHeaders(options)
  }

  try {
    const response = await fetch(url, options)
    const json = await response.json()
    clearTimeout(timeout)
    return {
      httpStatusCode: response.status,
      json,
    }
  } catch (e) {
    clearTimeout(timeout)
    store.dispatch('connectivity/checkOnlineStatus')

    if (e instanceof Error) {
      if (store.state.connectivity.isOnline && e.name === 'AbortError') {
        store.dispatch('connectivity/checkRequestTimeoutStatus')
      }
    }

    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}

export const patch = async (url: string, options?: RequestInit): Promise<HttpResponse> => {
  const controller = new AbortController()
  const timeout = setTimeout(() => {
    controller.abort()
  }, TIMEOUT_DURATION)

  if (!options) {
    options = {}
  }
  await LiffService.validateToken()
  options.method = 'PATCH'
  options.signal = controller.signal
  generateXRequestId(options)

  if (window && window.__LIFF_DEBUGGER_PARAMS && window.__LIFF_DEBUGGER_PARAMS.length) {
    attachDebuggerHeaders(options)
  }

  try {
    const response = await fetch(url, options)
    const json = await response.json()
    clearTimeout(timeout)
    return {
      httpStatusCode: response.status,
      json,
    }
  } catch (e) {
    clearTimeout(timeout)
    store.dispatch('connectivity/checkOnlineStatus')

    if (e instanceof Error) {
      if (store.state.connectivity.isOnline && e.name === 'AbortError') {
        store.dispatch('connectivity/checkRequestTimeoutStatus')
      }
    }

    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}

export const post = async (url: string, options?: RequestInit): Promise<HttpResponse> => {
  const controller = new AbortController()
  const timeout = setTimeout(() => {
    controller.abort()
  }, TIMEOUT_DURATION)

  if (!options) {
    options = {}
  }
  await LiffService.validateToken()
  options.method = 'POST'
  options.signal = controller.signal
  generateXRequestId(options)

  if (window && window.__LIFF_DEBUGGER_PARAMS && window.__LIFF_DEBUGGER_PARAMS.length) {
    attachDebuggerHeaders(options)
  }

  try {
    const response = await fetch(url, options)
    const json = await response.json()
    clearTimeout(timeout)
    return {
      httpStatusCode: response.status,
      json,
    }
  } catch (e) {
    clearTimeout(timeout)
    store.dispatch('connectivity/checkOnlineStatus')

    if (e instanceof Error) {
      if (store.state.connectivity.isOnline && e.name === 'AbortError') {
        store.dispatch('connectivity/checkRequestTimeoutStatus')
      }
    }

    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}
